export default "__VITE_ASSET__7JzsyoE7__"